module.exports = __webpack_public_path__ + "static/media/licenca_verso.d2cf9715.png";